import { useNavigate } from "react-router-dom";
import GestionBusquedaContenido from "./../../../components/templates/GestionBusqueda/GestionBusquedaContenido";
import Titulo from "../../../components/atoms/titles/Titulo";
import Button from "./../../../components/atoms/buttons/Button";
import Header from "../../../components/molecules/header/Header";
import Footer from "../../../components/molecules/footer/Footer";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header></Header>
      <div className="container vh-100 d-flex pt-5" role="main" data-landmark-index="4">
        <div className="caja-gestion-busqueda-acciones col-12 d-flex flex-column align-items-center">
          <Titulo tipo={"tituloModal"} titulo={"Página no encontrada"} />
          <GestionBusquedaContenido>
            <span className="text-center text-third-2 error-no-text">
              404 NOT FOUND <br />
              La dirección :{" "}
              <span className="text-center error-no-text">
                {window.location.pathname}{" "}
              </span>{" "}
              No existe
            </span>

            <div className="botones-contenido-abajo d-flex justify-content-end">
              <Button
                id="filtrarSolicitud"
                clases="btn-standard align-self-end"
                nombre="Aceptar"
                funcion={() => {
                  navigate("/home");
                }}
              />
            </div>
          </GestionBusquedaContenido>
          <div className="caja_media accionesUsuario-scroll-list"></div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
};

export default NotFound;
